// Custom hook for idle detection
import { useEffect, useRef, useCallback, useState } from 'react';

const DELAY = 180000;

const useIdleDetection = (onIdle, timeout = DELAY) => {
  const timeoutRef = useRef(null);
  const [isActive, setIsActive] = useState(true);

  const resetTimer = useCallback(() => {

    if (!isActive) return;


    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }


    timeoutRef.current = setTimeout(() => {
      if (isActive && onIdle && typeof onIdle === 'function') {
        onIdle();
        resetTimer();
      }
    }, timeout);
  }, [onIdle, timeout, isActive]);

  const stopIdleDetection = useCallback(() => {
    setIsActive(false);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  useEffect(() => {
    if (!isActive) return;

    // const events = ['mousedown', 'mousemove', 'mouseup', 'click'];
    const events = ['click'];

    events.forEach(event => {
      document.addEventListener(event, resetTimer, true);
    });

    resetTimer();

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, resetTimer, true);
      });
      
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [resetTimer, isActive]);

  return stopIdleDetection;
};

export default useIdleDetection;